import { render, staticRenderFns } from "./ModalEmpresasCampanha.vue?vue&type=template&id=2e7ed8da&scoped=true&"
import script from "./ModalEmpresasCampanha.vue?vue&type=script&lang=js&"
export * from "./ModalEmpresasCampanha.vue?vue&type=script&lang=js&"
import style0 from "./ModalEmpresasCampanha.vue?vue&type=style&index=0&id=2e7ed8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ed8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDialog,VDivider,VIcon,VSimpleTable,VSpacer,VToolbar,VToolbarTitle})
